
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-bug-fix",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-bug-fix"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{staticClass:"i-bug-fix__bug"},[_c('path',{attrs:{"d":"M7.93 5.22v1.64M5.16 7.9h1.69m-.09 2.75l3.34-4.24m-.24 5.8l-.04-.98m1.28-1.98h1.03m-1.58-1.08l.9-.71m-2.92 3.32l-.36.95"}}),_c('ellipse',{attrs:{"cx":"9","cy":"9","rx":"1.55","ry":"2.54","transform":"rotate(-45.4 9 9.003)"}})]),_c('g',{staticClass:"i-bug-fix__crosshairs"},[_c('circle',{staticClass:"i-clock__outline",attrs:{"cx":"9","cy":"9","r":"6.15"}}),_c('path',{attrs:{"d":"M9 15.01v-1.53m0-9.02V2.93M2.96 8.97h1.53m9.03 0h1.52"}})])])
          )
        }
      }
    